import { Directive, ElementRef, Host, Self, Optional, SimpleChange } from "@angular/core";
import { NgxMaskDirective, NgxMaskService } from "ngx-mask";
import { OnChanges, SimpleChanges } from "@angular/core";

@Directive({
  selector: "[customMask]"
})
export class CustomMaskDirective {
  constructor(@Host() @Self() @Optional() public hostSel: NgxMaskDirective) {
    // Now you can access specific instance members of host directive
    let simpleChange = new SimpleChange(null, hostSel.maskExpression, true);
    //hostSel.ngOnChanges({ maskExpression: simpleChange });
    hostSel.onChange({ maskExpression: simpleChange });
  }
}
